import './desktop-header-links-menu.scss';

const DESKTOPWIDTH = 1300;

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function resetMenu() {
  let menu = document.querySelector('#block-bigmenu');
  let selectorsToRemove = '.open, .selected, div[style*="display: block;"]';
  menu.querySelectorAll(selectorsToRemove).forEach((component) => {
    if (component.classList.contains('open')) {
      component.classList.remove('open');
    } else if (component.classList.contains('selected')) {
      component.classList.remove('selected');
    } else if (component.style.display == "block") {
      component.style.display = 'none';
    }
  });
  let selector = document.querySelector('.submenu-opened.submenu-lvl2-opened');
  if (selector) {
    selector.classList.remove('submenu-opened');
    selector.classList.remove('submenu-lvl2-opened');
  }
}

document.addEventListener('DOMContentLoaded', () => {

  // Function to open burger menu.
  function openBurgerMenu() {
    document.querySelectorAll('.mobile-burger-menu').forEach(menu => {
      menu.classList.add('show-burger-menu');
    });
    document.querySelector('#header-overlay').style.display = 'block';
    document.body.classList.add('prevent-scroll');
  }

  // Function to close burger menu.
  function closeBurgerMenu() {
    document.querySelectorAll('.mobile-burger-menu').forEach(menu => {
      menu.classList.remove('show-burger-menu');
    });
    document.querySelector('#header-overlay').style.display = 'none';
    document.body.classList.remove('prevent-scroll');

    // Reset menu to level 1 when closing on mobile.
    resetMenu();
  }

  // Function to check if burger menu is open.
  function isBurgerMenuOpen() {
    return document.querySelector('.mobile-burger-menu.show-burger-menu') !== null;
  }

  // Toggle opening of burger menu.
  document.querySelectorAll('.menu-burger-toggle').forEach(toggle => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();

      if (isBurgerMenuOpen()) {
        closeBurgerMenu();
      } else {
        openBurgerMenu();
      }
    });
  });

  // Close burger menu when clicking on overlay (outside menu).
  document.querySelector('#header-overlay').addEventListener('click', (event) => {
    event.preventDefault();
    closeBurgerMenu();
  });

  // make initial call to add class on page load.
  makeHeaderSticky();

  window.addEventListener('scroll', debounce(() => makeHeaderSticky(), 5));
  window.addEventListener('resize', debounce(() => {
    makeHeaderSticky();
    // Close burger menu on resize (e.g., when switching from mobile to desktop).
    if (window.innerWidth >= DESKTOPWIDTH && isBurgerMenuOpen()) {
      closeBurgerMenu();
    }
  }, 100));

  function makeHeaderSticky() {
    const header = document.getElementById('header');
    const headerHeight = header.clientHeight;
    const body = document.getElementsByTagName('body')[0];

    if (window.scrollY >= headerHeight) {
      body.classList.add('sticky-header')
      body.classList.remove('header-regular');
      resetMenu();
    }
    else {
      body.classList.remove('sticky-header');
      body.classList.add('header-regular');
    }

    if (window.innerWidth < DESKTOPWIDTH) {
      // mobile is always sticky menu format.
      body.classList.add('sticky-header')
      body.classList.remove('header-regular');
      resetMenu();
    }
  }

  // burger menu level 1 subitems click
  document.querySelectorAll('.mm__level-1 > .menuparent > .link-container > a').forEach(menuItm => {
    menuItm.addEventListener('click', (event) => {
      event.preventDefault();

      // close other .menuparent items at same level
      document.querySelectorAll('.mm__level-1 > .menuparent').forEach(otherItm => {
        if (otherItm !== menuItm.parentNode.parentNode) {
          otherItm.classList.remove('open');
        }
      });

      // toggle current element
      menuItm.parentNode.parentNode.classList.toggle('open');

      // add class to menu wrapper when a level 1 menu is opened
      document.getElementsByClassName('main-menu-wrap')[0].classList.toggle('submenu-opened');

      // re-init sublevels
      menuItm.parentNode.parentNode.querySelectorAll('ul.mm__level-2 > .menu-item').forEach(subItem => {
        subItem.classList.remove('burger-hidden');
      });

      // in desktop: open first subitem by default
      //tablet-landscape breakpoint
      if (window.innerWidth >= DESKTOPWIDTH) {
        if (document.body.classList.contains('header-regular')) {
          if (menuItm.parentNode.parentNode.querySelector('ul.mm__level-2 > .menu-item').classList.contains('allow-click')) {
            menuItm.parentNode.parentNode.querySelector('.mm__level-5-container.allow-click').classList.remove('hidden');
          } else {
            menuItm.parentNode.parentNode.querySelector('.mm__level-5-container').classList.remove('hidden');

            const animalLinkEL = menuItm.parentNode.parentNode.querySelector('.mm__level-2 .animal-production');
            if (animalLinkEL && !animalLinkEL.classList.contains('selected')) {
              animalLinkEL.querySelector('a').click();
            }
          }
        }
      }

    });
  });

  // burger menu level 2 subitems click (show panels)
  document.querySelectorAll('ul.mm__level-2 > .menu-item > a').forEach(menuItm => {
    menuItm.addEventListener('click', (event) => {
      const currentItem = event.target.closest('a');
      const menuPanel = document.getElementById(currentItem.getAttribute('data-menu-panel'));

      if (currentItem.hasAttribute('data-menu-panel') && menuPanel !== null) {
        if (!currentItem.parentNode.classList.contains('allow-click')) {
          event.preventDefault();
        }

        const menuPanelId = currentItem.getAttribute('data-menu-panel');
        const panel = document.getElementById(menuPanelId);
        const regardPanel = document.getElementById('regard_' + menuPanelId);

        // change status on level 2 links
        document.querySelectorAll('ul.mm__level-2 > .menu-item').forEach(menuItmToReset => {
          menuItmToReset.classList.remove('selected');
          menuItmToReset.classList.toggle('burger-hidden');
        });

        // close other panels
        document.querySelectorAll('.mm__level-3').forEach(otherPanel => {
          if (otherPanel !== panel) {
            otherPanel.style.display = 'none';
          }
        });

        document.querySelectorAll('.mm__level-5-container').forEach(otherPanel => {
          if (otherPanel !== regardPanel) {
            otherPanel.classList.toggle('hidden', true);
          }
        });

        // set classes on current clicked link
        currentItem.parentNode.classList.add('selected');
        currentItem.parentNode.classList.remove('burger-hidden');

        // add class to menu wrapper when a level 2 menu is opened
        document.getElementsByClassName('main-menu-wrap')[0].classList.toggle('submenu-lvl2-opened');

        // toggle clicked detail panel
        panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
        if (regardPanel) {
          regardPanel.classList.toggle('hidden', false);
        }

      }
    });
  });

});
